import { useQuery } from '@tanstack/react-query';
import { G_UNITS_QUERY_KEY } from 'constants/queryKeys';
import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from 'constants/appConstants';
import { GUnit } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

/**
 * Fetch ALL active GUnit records for an organisation.
 *
 * GUnit data changes infrequently, so staleTime matches the standard session
 * cache lifetime. gcTime is kept at the standard value — the data is re-fetched
 * on the next org open if the cache has expired.
 */
export const useFetchGUnits = (gOrgId: string | null) => {
  return useQuery<GUnit[]>({
    queryKey: [G_UNITS_QUERY_KEY, gOrgId],
    queryFn: () => GlobalCatalogueService.FetchGUnitData(null, gOrgId!),
    enabled: !!gOrgId,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
  });
};
